import {
  getHeroAddresses,
  type SOrdnerOut,
} from "@/lib/projects";
import { heroAddressPlaceLabel } from "@/pages/projekte/projectFilterSummary";

const addressTitleCache = new Map<string, string | null>();

function addressCacheKey(customerId: number, addressId: number): string {
  return `${customerId}:${addressId}`;
}

/** `undefined` = noch nicht nachgeschlagen, `null` = kein brauchbarer Name. */
export function peekSOrdnerAddressTitle(
  customerId: number | null | undefined,
  addressId: number | null | undefined,
): string | null | undefined {
  if (customerId == null || addressId == null) return null;
  const key = addressCacheKey(Number(customerId), Number(addressId));
  if (!addressTitleCache.has(key)) return undefined;
  return addressTitleCache.get(key) ?? null;
}

/** Hero-Adresse einmal je Kunde/Adresse auflösen und für weitere Ordner behalten. */
export async function resolveSOrdnerAddressTitle(
  hit: Pick<SOrdnerOut, "hero_customer_id" | "hero_address_id">,
): Promise<string | null> {
  const customerId = hit.hero_customer_id;
  const addressId = hit.hero_address_id;
  if (customerId == null || addressId == null) return null;
  const key = addressCacheKey(Number(customerId), Number(addressId));
  if (addressTitleCache.has(key)) return addressTitleCache.get(key) ?? null;
  try {
    const addresses = await getHeroAddresses(Number(customerId));
    const match = addresses.find((a) => Number(a.address_id) === Number(addressId));
    const label = match ? heroAddressPlaceLabel(match) : null;
    addressTitleCache.set(key, label);
    return label;
  } catch {
    return null;
  }
}
